import { ButtonProps } from "@components/ui/Button"
import { ticketModals } from "@features/ferve/tickets-modal"
import { trackEvent } from "@features/tracking/tracking"
import { ButtonFragment, SessionTicketsFragment } from "@generated-types"
import { MouseEvent } from "react"
import { useTFF } from "./useTFF"
import { useHydrating } from "eddev/routing"

type Args = ButtonFragment | undefined | null

type OutputProps = Pick<ButtonProps, "children" | "icon" | "variant" | "onClick" | "href" | "target">

export function useButtonProps(
  args: Args,
  options: {
    defaultVariant: ButtonProps["variant"]
    primaryVariant: ButtonProps["variant"]
  } = { defaultVariant: "default", primaryVariant: "primary" },
): OutputProps {
  const hydrating = useHydrating()
  let onClick: ((e: MouseEvent) => void) | undefined = undefined
  let href = args?.url

  const tff = useTFF()

  if (href?.match(/\/tff\/tickets\/?/) && tff.centerSlug && !hydrating) {
    href = `/tff/tickets/${tff.centerSlug}/`
  }

  if (args?.ferveHash) {
    href = null
    onClick = (e: MouseEvent) => {
      e.preventDefault()
      ticketModals.push({
        type: "embed",
        itemHash: args.ferveHash!,
      })
      trackEvent("Ferve Button Click", { ButtonLabel: args.title }, e.currentTarget as any)
    }
  } else if (args?.ferveFilm?.sessions?.length) {
    onClick = (e: MouseEvent) => {
      if (!e.ctrlKey && !e.metaKey && !e.shiftKey) {
        e.preventDefault()
        ticketModals.push({
          type: "sessions",
          sessions: args.ferveFilm?.sessions as SessionTicketsFragment[],
        })
        trackEvent("Ferve Button Click", { ButtonLabel: args.title }, e.currentTarget as any)
      }
    }
  }

  return {
    children: args?.title ?? "",
    icon: args?.icon!,
    variant: args?.primary ? options.primaryVariant : options.defaultVariant,
    onClick: onClick,
    href: href,
    target: args?.target,
  }
}
